<div
  class="flex flex-col"
  *ngIf="form && definition"
  [ngSwitch]="definition.control"
>
  <label class="soft-label top"
    >{{ definition.title }}
    <span
      class="required-indicator"
      *ngIf="definition.required | booleanRule: form.value"
      >*</span
    >
  </label>
  <soft-multiline-input
    *ngSwitchCase="'multiline'"
    [formControl]="form|formControl:definition.name"
    [readonly]="definition.readonly | booleanRule: form.value"
    softFieldValidation
  >
  </soft-multiline-input>
  <soft-input
    *ngSwitchDefault
    [formControl]="form|formControl:definition.name"
    [readonly]="definition.readonly | booleanRule: form.value"
    [softScan]="(definition | scanDefinition)?.scan ?? false"
    [labelTypes]="(definition | scanDefinition)?.labelTypes"
    softFieldValidation
    #value
  >
  </soft-input>
</div>
